export default __webpack_public_path__ + "static/media/landing.370ba8b4.png";